import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	FormGroup,
	Row,
	Card,
	CardImg,
	CardBody,
	CardText,
	Badge,
	Nav,
	NavItem,
	NavLink,
	TabContent,
	TabPane,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Breadcrumb,
	BreadcrumbItem,
} from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import compoundLogo from "assets/images/compound.png";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import InterestServices from "services/Website/InterestServices";
import { SuccessOk } from "configs/statusCode";
import ResaleCard from "components/Website/Cards/ResaleCard";
import UnitCard from "components/Website/Cards/UnitCard";
import { useTranslation } from "react-i18next";
import Paginator from "../Paginator";

const MayInterests = (props) => {
	const [interests, setInterestes] = useState([]);
	const { t } = useTranslation();
	const interestServices = new InterestServices();
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});
	const updateProfileInterest = (id, type) => {
		const updatedInterests = interests.filter((interest) => {
			if (interest.id === id && interest.type === type) {
				return false;
			} else {
				return true;
			}
		});
		setInterestes([...updatedInterests]);
	};
	return (
		<div className="websitPages tab-details interst-tab">
			<div className="px-lg-5 px-3 py-5">
				<Row>
					<Col md={12}>
						<h3
							className="text-primary fw-bold font-size-26"
							dangerouslySetInnerHTML={{
								__html: t("My Interests Title"),
							}}></h3>
						<Row className="pt-3">
							{interests.map((interest, index) => {
								if (interest.type === "resale") {
									return (
										<Col xl={4} md={6} sm={6} className="mb-3" key={index}>
											<ResaleCard
												resale={interest.data}
												history={props.history}
												profile={true}
												loaction={props.loaction}
												updateProfileInterest={() =>
													updateProfileInterest(interest.id, interest.type)
												}
											/>
										</Col>
									);
								} else {
									return (
										<Col xl={4} md={6} className="mb-3" key={index}>
											<UnitCard
												item={interest.data}
												index={index}
												history={props.history}
												profile={true}
												updateProfileInterest={() =>
													updateProfileInterest(interest.id, interest.type)
												}
											/>
										</Col>
									);
								}
							})}
						</Row>
					</Col>
				</Row>
				<Row className="d-flex justify-content-end">
					<Col className="d-flex justify-content-end" md={12}>
						<Paginator
							service={interestServices}
							pageOptions={pageOptions}
							setData={(data) => setInterestes([...data])}
							setPageOptions={setPageOptions}
							shouldGetData={false}
							setShouldGetData={() => {}}
						/>
					</Col>
				</Row>
			</div>
		</div>
	);
};
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default MayInterests;
